<template>
    <v-card>
        <v-tabs class="text-green" v-model="tab" align-tabs="center" stacked>
            <v-tab value="tab-1">
                <v-icon>mdi-account-convert</v-icon>
                CRO
            </v-tab>

            <v-tab value="tab-2">
                <v-icon>mdi-text-box-plus</v-icon>
                Blogs
            </v-tab>

            <v-tab value="tab-3">
                <v-icon>mdi-account-box-multiple</v-icon>
                RRSS
            </v-tab>
            <v-tab value="tab-4">
                <v-icon>mdi-google-ads</v-icon>
                SEM
            </v-tab>
        </v-tabs>

        <v-window v-model="tab">
            <v-window-item value="tab-1">
                <v-col class="d-flex justify-center">
                    <v-img src="/img/cro.svg" height="300">
                    </v-img>
                </v-col>
                <v-card-title>
                    <h5>CRO</h5>
                </v-card-title>
                <v-card>
                    <v-card-text>
                        Optimiza tu conversión con nuestro servicio de CRO. Analizamos y mejoramos tu sitio web para
                        incrementar las acciones deseadas de los visitantes, desde compras hasta registros. A través de
                        tests y análisis de datos, transformamos tu tráfico en resultados tangibles, maximizando el ROI
                        de tu presencia online.
                    </v-card-text>
                </v-card>
            </v-window-item>
            <v-window-item value="tab-2">
                <v-col class="d-flex justify-center">
                    <v-img src="/img/blogs.svg" height="300">
                    </v-img>
                </v-col>
                <v-card-title>
                    <h5>BLOGS</h5>
                </v-card-title>
                <v-card>
                    <v-card-text>
                        Impulsa tu estrategia digital con nuestro servicio de creación y gestión de contenido para
                        blogs. Generamos artículos relevantes, optimizados para SEO, que atraen y retienen a tu
                        audiencia. Convertimos tu blog en una herramienta poderosa para el crecimiento orgánico.
                    </v-card-text>
                </v-card>
            </v-window-item>
            <v-window-item value="tab-3">
                <v-col class="d-flex justify-center">
                    <v-img src="/img/rrss.svg" height="300">
                    </v-img>
                </v-col>
                <v-card-title>
                    <h5>SOCIAL MEDIA</h5>
                </v-card-title>
                <v-card>
                    <v-card-text>
                        Eleva tu presencia en redes sociales con nuestro servicio integral. Desde la creación de
                        contenido relevante hasta la gestión de interacciones, amplificamos tu voz en plataformas clave
                        con la audiencia correcta. Fomentamos el engagement
                        y crecimiento, posicionando tu marca en el corazón de la conversación digital.
                    </v-card-text>
                </v-card>
            </v-window-item>
            <v-window-item value="tab-4">
                <v-col class="d-flex justify-center">
                    <v-img src="/img/sem.svg" height="300">
                    </v-img>
                </v-col>
                <v-card-title>
                    <h5>SEM</h5>
                </v-card-title>
                <v-card>
                    <v-card-text>
                        Potencia tu visibilidad online con nuestro servicio de SEM. Creamos y gestionamos campañas en
                        Google Ads y Bing Ads, diseñadas para captar tu audiencia objetivo y generar leads de calidad.
                        Con análisis y optimización constantes, aseguramos el máximo ROI, colocando tu
                        marca en los primeros puestos de búsqueda cuando tus clientes más lo necesitan.
                    </v-card-text>
                </v-card>
            </v-window-item>
        </v-window>
    </v-card>
</template>
<script>
export default {
    name: "otherServices",
    data() {
        return {
            tab: null,
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
        }
    },
}
</script>